<form [formGroup]="validClientForm" (ngSubmit)="onSubmitTemplate()">
  <!-- ? Teléfono -->
  <ion-item
    mode="md"
    lines="none"
    color="gray"
    class="mpe-input-square-floating"
  >
    <ion-label position="floating" mode="md" color="status-icon-enable">
      <ion-text mode="md" color="danger">
        {{ "Forms.asterisk" | translate }}
      </ion-text>
      {{ "Forms.number-of-phone" | translate }}
    </ion-label>

    <ion-input
      [attr.data-test]="'Automation.txtbox-registration-phone' | translate"
      type="tel"
      formControlName="phone"
      #phone
      oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1')"
      mode="ios"
      color="medium"
      debounce="300"
      minlength="10"
      maxlength="10"
      enterkeyhint="next"
      (keydown.enter)="gotoNextField(nud)"
      [ngClass]="
        (validClientForm.get('phone').value | isNullEmpty)
          ? 'border-base'
          : validClientForm.get('phone').invalid
          ? 'border-danger'
          : 'border-valid'
      "
    >
    </ion-input>
    <!-- Manejo de Mensajes Reactivos -->
    <ng-container
      *ngIf="
        !(validClientForm.get('phone').value | isNullEmpty) &&
        validClientForm.get('phone').invalid
      "
    >
      <p>{{ "Labels.invalid-phone" | translate }}</p>
    </ng-container>
  </ion-item>

  <!-- ? NUD -->
  <ion-item
    mode="md"
    lines="none"
    color="gray"
    class="mpe-input-square-floating"
  >
    <ion-label position="floating" mode="md" color="status-icon-enable">
      <ion-text mode="md" color="danger">
        {{ "Forms.asterisk" | translate }}
      </ion-text>
      {{ "Forms.client-number" | translate }}
    </ion-label>

    <ion-input
      [attr.data-test]="'Automation.txtbox-registration-nud' | translate"
      type="tel"
      formControlName="nud"
      #nud
      oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1')"
      mode="ios"
      color="medium"
      debounce="300"
      minlength="1"
      maxlength="10"
      max="2147483646"
      enterkeyhint="next"
      (keydown.enter)="gotoNextField(bodega)"
      [ngClass]="
        (validClientForm.get('nud').value | isNullEmpty)
          ? 'border-base'
          : validClientForm.get('nud').invalid
          ? 'border-danger'
          : 'border-valid'
      "
    >
    </ion-input>
  </ion-item>

  <!-- ? Bodega -->
  <ion-item
    mode="md"
    lines="none"
    color="gray"
    class="mpe-input-square-floating"
  >
    <ion-label position="floating" mode="md" color="status-icon-enable">
      <ion-text mode="md" color="danger">
        {{ "Forms.asterisk" | translate }}
      </ion-text>
      {{ "Forms.warehouse-number" | translate }}
    </ion-label>

    <ion-input
      [attr.data-test]="'Automation.txtbox-registration-bodega' | translate"
      type="tel"
      formControlName="bodega"
      #bodega
      oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1')"
      mode="ios"
      color="medium"
      debounce="300"
      minlength="3"
      maxlength="3"
      enterkeyhint="done"
      [ngClass]="
        (validClientForm.get('bodega').value | isNullEmpty)
          ? 'border-base'
          : validClientForm.get('bodega').invalid
          ? 'border-danger'
          : 'border-valid'
      "
    >
    </ion-input>
  </ion-item>

  <!-- ? Terminos -->
  <ion-list mode="ios" lines="none" class="list-TC-AV">
    <ion-item
      mode="md"
      lines="none"
      color="gray"
      class="mpe-no-focused item-TC-AV"
    >
      <ion-checkbox
        [attr.data-test]="'Automation.chkbox-registration-terms' | translate"
        mode="md"
        color="darkblue"
        name="isTerminos"
        slot="start"
        required
        formControlName="isTerminos"
        (change)="validateCheck()"
      ></ion-checkbox>

      <ion-button
        [attr.data-test]="'Automation.link-registration-terms' | translate"
        class="mpe-button-link-line ion-no-padding"
        size="default"
        mode="md"
        fill="clear"
        color="darkblue"
        (click)="openTerminos('isTerminos')"
      >
        <ion-label mode="md" color="darkblue" class="label-tc-av">
          Acepto T&eacute;rminos y Condiciones
        </ion-label>
      </ion-button>
    </ion-item>

    <!-- ? Aviso -->
    <ion-item
      mode="md"
      lines="none"
      color="gray"
      class="mpe-no-focused item-TC-AV"
    >
      <ion-checkbox
        [attr.data-test]="'Automation.chkbox-registration-privacy' | translate"
        mode="md"
        color="darkblue"
        name="isAviso"
        slot="start"
        required
        formControlName="isAviso"
        (change)="validateCheck()"
      ></ion-checkbox>

      <ion-button
        [attr.data-test]="'Automation.link-registration-privacy' | translate"
        class="mpe-button-link-line ion-no-padding"
        size="default"
        mode="md"
        fill="clear"
        color="darkblue"
        (click)="openTerminos('isAviso')"
      >
        <ion-label mode="md" color="darkblue" class="label-tc-av">
          Acepto Aviso de privacidad
        </ion-label>
      </ion-button>
    </ion-item>
  </ion-list>

  <!-- ? Accep -->
  <ion-item class="ion-no-padding" lines="none" mode="md" color="gray">
    <ion-button
      class="aceptar"
      [disabled]="validClientForm.invalid || spinner"
      type="submit"
    >
      <ion-spinner name="crescent" slot="start" *ngIf="spinner"></ion-spinner>
      <ion-label mode="md">
        {{ "Buttons.continue" | translate }}
      </ion-label>
    </ion-button>
  </ion-item>
</form>
